import React from "react";
import PublicFeatureLandingPage from "../../../../platform/components/common/PublicFeatureLandingPage";
import { buildCareJobsPostShareMessage } from "../../../../platform/util/publicShareMessages";

const SHARE_PATH = "/care/jobs/post";
const JOB_POST_RETURN_TO = "/biz/manage/jobs?v=care";
const START_PATH = `/start-free-trial?returnTo=${encodeURIComponent(JOB_POST_RETURN_TO)}`;
const LOGIN_PATH = `/login?returnTo=${encodeURIComponent(JOB_POST_RETURN_TO)}`;

export default function JobPostLandingPage(): JSX.Element {
  return (
    <PublicFeatureLandingPage
      path={SHARE_PATH}
      seoTitle="Post a Care Job | Plany365"
      seoDescription="Start your hiring setup on Plany365 and post a care job for caregivers or staff."
      eyebrow="Hiring"
      title="Post a caregiving job"
      description="Share your open role on Plany365 and start receiving applicants for caregivers and care staff."
      highlights={[
        "Post jobs for caregivers, med techs, and support staff.",
        "Manage job postings from your hiring workspace.",
        "Keep one shareable page ready for social posts and outreach.",
      ]}
      actions={[
        {
          label: "Start Posting Jobs",
          href: START_PATH,
          variant: "contained",
        },
        {
          label: "I already have an account",
          href: LOGIN_PATH,
          variant: "outlined",
        },
      ]}
      buildShareMessage={buildCareJobsPostShareMessage}
      shareDescription="Use this message when you want to invite a provider to post an open job."
    />
  );
}
